module.exports = __webpack_public_path__ + "static/media/pumba.62e2f832.jpg";